module.exports = __webpack_public_path__ + "img/note-add-black-24-dp.b45796a1.svg";